// Formats the value of number or string to a price
// Example : 200000 = $200,000

export const FormatToPriceTemplate = (value: number | string, prefix: string = '$'): string => {
  // Convert the value to a string if it's not already
  const strValue: string = typeof value === 'number' ? value.toString() : value;

  // Split the string into integer and decimal parts (if decimal exists)
  const [integerPart, decimalPart] = strValue.split('.');

  // Add commas to the integer part
  const formattedInteger: string = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  // Combine the formatted integer part and decimal part (if exists) with the specified prefix
  const formattedValue: string = `${prefix}${formattedInteger}${decimalPart ? `.${decimalPart}` : ''}`;

  return formattedValue;
};

// Helper function to format numbers as "$XK" (thousands)
export const FormatToShortPriceTemplate = (num: number, prefix: string = '$', fixed: number = 1) => {
  if (num >= 1_000_000) {
    return `${prefix}${(num / 1_000_000).toFixed(fixed)}M`;
  }
  if (num >= 1_000) {
    return `${prefix}${(num / 1_000).toFixed(fixed)}K`;
  }
  if (num <= -1_000_000) {
    return `${prefix}${(num / 1_000_000).toFixed(fixed)}M`;
  }
  if (num <= -1_000) {
    return `${prefix}${(num / 1_000).toFixed(fixed)}K`;
  }

  return `${prefix}${num.toFixed(fixed)}`;
};

export const formatToPriceInDollars = (value: number, numbersAfterZero: number = 0, currency: string = 'USD') => {
  return value.toLocaleString('en-US', {
    style: 'currency',
    currency: currency.replace('=', ''),
    maximumFractionDigits: numbersAfterZero,
  });
};

export const formatToShortString = (value: number, digitsAfterZero: number = 2): string => {
  return value.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: digitsAfterZero });
};

export const capitalFirst = (word: string): string => word.replace(/^./, (match) => match.toUpperCase());
